import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Filters } from './Filters';
import { createRoot } from 'react-dom/client';
import { StoreContextProvider } from '../contexts/storeContext';
import { PaginationControllers } from './Pagination/PaginationControllers';
import { SKU_REGEXP } from '../config';
function addDataAttributes(stateItems, gameCardElements) {
    gameCardElements.forEach((gameCardEl) => {
        const sku = gameCardEl.dataset.sku;
        if (!sku)
            return;
        const foundGame = stateItems.find((el) => el.sku === sku);
        if (!foundGame)
            return;
        foundGame.attributes.forEach((attribute) => {
            const values = attribute.values.map((value) => value.value);
            const dataAttributeName = `data-${attribute.externalId}`;
            gameCardEl.setAttribute(dataAttributeName, JSON.stringify(values));
            gameCardEl.setAttribute('data-game-name', foundGame.name);
        });
    });
}
function addSkuToItems(cards) {
    Array.from(cards).forEach((card) => {
        const id = card.id;
        const sku = id.match(SKU_REGEXP);
        if (!sku)
            return;
        card.setAttribute('data-sku', sku[1]);
    });
}
export const createFilters = (games, element, state) => {
    const GameCards = element.querySelectorAll('.new-store-card');
    const StoreTitle = element.querySelector('.new-store div[data-testid="section-title"] h2');
    addSkuToItems(GameCards);
    addDataAttributes(games, GameCards);
    const FiltersEl = document.createElement('div');
    FiltersEl.classList.add('new-store__filters-pagination');
    StoreTitle?.replaceWith(FiltersEl);
    const root = createRoot(FiltersEl);
    root.render(_jsxs(StoreContextProvider, { children: [_jsx(Filters, { element: element, state: state }), _jsx(PaginationControllers, { element: element, URLName: "page" })] }));
};
